import React, { useEffect, useRef } from "react";

/**
 * Theme OTP / MPIN boxes — no MUI OTP package (avoids React duplicate hook errors).
 */
const AuthOtpInput = ({
  length = 6,
  value = "",
  onChange,
  autoFocus = false,
  type = "password",
  className = "",
}) => {
  const refs = useRef([]);
  const digits = String(value || "")
    .replace(/\D/g, "")
    .slice(0, length)
    .split("");

  useEffect(() => {
    if (autoFocus) {
      refs.current[0]?.focus();
    }
  }, [autoFocus]);

  const emit = (next) => {
    onChange?.(next.slice(0, length));
  };

  const handleChange = (raw, index) => {
    const char = String(raw).replace(/\D/g, "").slice(-1);
    const next = Array.from({ length }, (_, i) => digits[i] || "");
    next[index] = char;
    const joined = next.join("");
    emit(joined);
    if (char && index < length - 1) {
      refs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      refs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      refs.current[index - 1]?.focus();
    }
    if (e.key === "ArrowRight" && index < length - 1) {
      e.preventDefault();
      refs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    if (!text) return;
    emit(text);
    const focusAt = Math.min(text.length, length - 1);
    refs.current[focusAt]?.focus();
  };

  return (
    <div className={`ds-auth-otp ${className}`.trim()} onPaste={handlePaste}>
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el;
          }}
          className="ds-input ds-auth-otp__cell"
          type={type === "password" ? "password" : "text"}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={1}
          value={digits[i] || ""}
          onChange={(e) => handleChange(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          onFocus={(e) => e.target.select()}
          aria-label={`Digit ${i + 1}`}
        />
      ))}
    </div>
  );
};

export default AuthOtpInput;
